import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c987c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pace pace-inactive" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "pace-progress",
    "data-progress-text": "100%",
    "data-progress": "99",
    style: {"transform":"translate3d(100%, 0px, 0px)"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "pace-progress-inner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "pace-activity" })
], -1))
const _hoisted_2 = { class: "blankpage-form-field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-logo m-0 w-100 align-items-center justify-content-center rounded border-bottom-left-radius-0 border-bottom-right-radius-0 px-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:void(0)",
    class: "page-logo-link press-scale-down d-flex align-items-center"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "img/logo.jpg",
      alt: "mediadept logo",
      "aria-roledescription": "logo"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "page-logo-text mr-1" }, " 業務管理システム")
  ])
], -1))
const _hoisted_4 = { class: "card p-4 border-top-left-radius-0 border-top-right-radius-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loader",
  id: "loaderLgin",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"margin-top":"90px"},
    class: "fal fa-spinner-third fa-spin-4x fs-xxl"
  })
], -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "username"
}, "ログインID", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "password"
}, "パスワード", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"login-footer p-2\" data-v-1c987c46><div class=\"row\" data-v-1c987c46><div class=\"col col-sm-12 text-center\" data-v-1c987c46><i data-v-1c987c46><strong data-v-1c987c46>System Message:ver 20260902041752</strong></i></div></div></div><div class=\"loginbg\" data-v-1c987c46><img src=\"/img/backgrounds/loginbg.jpg\" alt=\"\" style=\"width:100%;height:100%;object-fit:cover;\" data-v-1c987c46></div>", 2)
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            id: "username",
            class: "form-control",
            placeholder: "ログインID",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginid) = $event))
          }, null, 512), [
            [_vModelText, _ctx.loginid]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            id: "password",
            class: "form-control",
            placeholder: "パスワード",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginpass) = $event))
          }, null, 512), [
            [_vModelText, _ctx.loginpass]
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.login())),
          class: "btn btn-default float-right waves-effect waves-themed",
          disabled: _ctx.btnDisable
        }, " ログイン ", 8, _hoisted_10)
      ])
    ]),
    _hoisted_11,
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal" }, {
      title: _withCtx(() => [
        _hoisted_13,
        _createTextVNode(_toDisplayString(_ctx.message4Modal), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_14
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 閉じる ")
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}